import { getTheme } from "../../../../managers/theme/ThemeManager";
import {
  PADDING,
  MARGIN,
  CUSTOM_FONT,
  CUSTOM_COLOUR,
  CUSTOM_DRIVER_COLOUR
} from "../../../../values/Typography";

const styles = theme => {
  const configTheme = getTheme();

  return {
    formPaper: {
      flex: 1,
      paddingBottom: theme.spacing.unit * 5,
      paddingTop: theme.spacing.unit * 2
    },
    parentView: {
      marginTop: "20vh",
      height: "50vh",
      paddingRight: theme.spacing.unit * 10
    },
    textView: {
      paddingTop: theme.spacing.unit * 2
    },
    imageView: {
      //justify:'center',
      // padding:theme.spacing.unit*4
    },
    footerTitle: {
      color: "white",
      fontFamily: CUSTOM_FONT
    },
    footerText: {
      color: "white",
      fontFamily: CUSTOM_FONT
    },
    media: {
      height: "100%",
      width: "60%",
      color: "white"
    },
    footerDiv: {},
    footerTitlePart: {
      fontWeight: "bold",
      color: "white",
      fontFamily: CUSTOM_FONT
    },
    backgroundImage: {
      height: "100vh"
      // width:'100vw',
    },
    logoContainer: {
      flex: 1,
      paddingRight: theme.spacing.unit
    },
    loginFormSheet: {
      paddingRight: theme.spacing.unit * 10,
      paddingLeft: theme.spacing.unit * 10,
      paddingTop: theme.spacing.unit * 5,
      paddingBottom: theme.spacing.unit * 5,
      flex: 1
    },
    loginTitle: {
      fontFamily: CUSTOM_FONT,
      fontWeight: "bold",
      marginTop: 20
    },
    userNameStyle: {
      width: "50%",
      height: 100,
      fontFamily: CUSTOM_FONT
    },
    SignupButton: {
      backgroundColor: CUSTOM_DRIVER_COLOUR,
      fontFamily: CUSTOM_FONT,
      fontSize: 18,
      textTransform: "none",
      width: "100%",
      marginTop: 20,
      height: "5vh",
      color: "black",
      fontWeight: "bold"
    },
    FPbutton: {
      textTransform: "none",
      fontFamily: CUSTOM_FONT,
      fontSize: 18,
      fontWeight: "bold"
    },
    SUbutton: {
      textTransform: "none",
      fontFamily: CUSTOM_FONT,
      fontSize: 18,
      fontWeight: "bold"
    },
    helperText: {
      fontFamily: CUSTOM_FONT,
      fontSize: 18,
      fontWeight: "bold"
    },
    textFeild: {
      fontFamily: CUSTOM_FONT,
      fontSize: 22,
      border: "0px solid",
      outline: "none !important"
    },

    formLink: {
      textTransform: "none",
      fontFamily: CUSTOM_FONT,
      fontSize: 9
    },
    linkContainer: {
      paddingRight: theme.spacing.unit * 3,
      paddingLeft: theme.spacing.unit * 3,
      marginTop: 20
    },
    formContainer: {
      padding: theme.spacing.unit,
      paddingRight: theme.spacing.unit * 5,
      paddingLeft: theme.spacing.unit * 5
    },
    bottomLineElement: {
      height: "50vh",
      marginTop: "4vh"
    },
    fieldContainer: {
      flex: 1
    },
    passwordGrid: {
      marginTop: 20
    },
    avatarText: {
      fontFamily: CUSTOM_FONT,
      fontSize: "1rem",
      marginRight: 20,
      marginLeft: 20
    },
    avatarContainer: {
      backgroundColor: "silver",
      border: "1px solid gray",
      borderRadius: 5,
      paddingTop: theme.spacing.unit * 5,
      paddingBottom: theme.spacing.unit * 5,
      paddingRight: theme.spacing.unit * 5,
      paddingLeft: theme.spacing.unit * 5
      //height:'30vh'
    },
    avatarGrid: {
      paddingRight: theme.spacing.unit * 3,
      paddingLeft: theme.spacing.unit * 3
    },
    stageLabel: {
      fontFamily: CUSTOM_FONT,
      fontSize: 14,
      color: "blue"
    }
  };
};

export default styles;
